export enum PaymentMethod {
  Stripe = "Stripe",
  Invoice = "Invoice",
}
